import { RimsPaymentMethod } from './rims-payment-method';

export const PaymentMethods = () => {
    return (
        <div data-testid="payment-methods">
            <RimsPaymentMethod />
        </div>
    );
};
